export default {
  title: "Forgot password",
  input: {
    email: {
      label: "Email address",
    },
  },
  button: {
    submit: "Send email",
    cancel: "Cancel",
  },
  warning: {
    noEmail: "Please fill in your email address.",
  },
  success: {
    emailSent: "You will receive an email with instructions shortly.",
  },
  api: {
    email: {
      invalid: "This is not a valid email address",
    },
  },
}
